'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

var index = utils.createSimpleFC({
  name: 'button-group',
  className: function className(_ref) {
    var props = _ref.props;
    return ['group', {
      vertical: utils.hasProp(props.vertical)
    }];
  }
});

exports.default = index;
